import { constants } from '~/config';
import { MetricCardType } from '~/containers/Dashboard/OverView/constants';

import { firebaseClient } from '../../firebaseClient';
import type { DashboardSettings } from '../types';

export type PostHideMetricBody = {
  accountId: number;
  agentId: number;
  metric: MetricCardType['id'];
};

export const postHideMetric = ({
  accountId,
  agentId,
  metric,
}: PostHideMetricBody) =>
  firebaseClient.post<DashboardSettings>('/hideMetric', {
    orgID: accountId,
    chatbotID: agentId,
    env: constants.app_env,
    metric,
  });
